function modifyId(id: string) {
  if (id) return id.split("-")[0].toLocaleUpperCase();
  return "-";
}

export default modifyId;
